<template>
  <div class="col-md-8 col-sm-6 d-flex">
    <div class="card">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col-6">
            <h5 class="card-title">Report</h5>
          </div>
          <div class="col-6">
            <div class="year-report d-flex justify-content-end">
              <div class="calendar-report">
                <span class="select-clendear-icon"
                  ><i class="bx bx-calendar-alt"></i
                ></span>
                <vue-select :options="ReportYear" id="reportyear" placeholder="Year" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <apexchart type="area" height="250" :options="Chart.chart" :series="Chart.series">
        </apexchart>
      </div>
    </div>
  </div>
</template>
<script>
import { Chart } from "./data";
export default {
  data() {
    return {
      select2: null,
      Chart: Chart,
      ReportYear: ["Year", "Month"],
    };
  },
};
</script>
